// extracted by mini-css-extract-plugin
export default {"Music":"music_Music__rZQiI","video":"music_video__-mNJJ"};